import React from "react";
import { Input } from "@windmill/react-ui";

const InputAreaPrime = ({
  register,
  defaultValue,
  required,
  name,
  label,
  type,
  placeholder,
  pattern,
  minLength,
  maxLength,
  value = 0,
  readOnly,
  onChangeFunction,
}) => {
  const handleInput = (e) => {
    let val = e.target.value;
    val = val.replace(/[^0-9]/g, "");

    if (maxLength && val.length > maxLength) {
      val = val.slice(0, maxLength);
    }

    e.target.value = val;

    if (onChangeFunction) {
      onChangeFunction(val);
    }
  };
  return (
    <>
      <Input
        {...register(`${name}`)}
        defaultValue={defaultValue}
        type={type}
        placeholder={placeholder}
        name={name}
        onInput={handleInput}
        onChange={(e) => onChangeFunction(e)}
        value={value}
        step="any"
        readOnly={readOnly}
        autoComplete="off"
        className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      />
    </>
  );
};

export default InputAreaPrime;
